export default "__VITE_ASSET__BM182js5__"